import { Deserializable } from 'rome-library';

export class UnreadMessageDto implements Deserializable {
  public CaseID: number;
  public CaseIDHash: string;
  public CaseType: string;
  public AlertsCount: number;
  public SamID: string;
  public SamIDHash: string;

  public deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
